import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./About.css";

function About() {
  const { t } = useTranslation();

  return (
    <main className="about-page">

      {/* ================= HERO ================= */}

      <section className="about-hero">
        <div className="about-hero-content">

          <span className="about-tag">
            ✦ {t("about.tag")}
          </span>

          <h1>
            {t("about.title")}
            <span>{t("about.titleHighlight")}</span>
          </h1>

          <p>
            {t("about.description")}
          </p>

        </div>

        <div className="about-hero-shape shape-one" />
        <div className="about-hero-shape shape-two" />
      </section>


      {/* ================= INTRO ================= */}

      <section className="about-intro section">

        <div className="about-intro-text">

          <span className="section-tag">
            {t("about.introTag")}
          </span>

          <h2>
            {t("about.introTitle")}
          </h2>

          <p>
            {t("about.introText")}
          </p>

          <Link
            to="/registration"
            className="about-button"
          >
            {t("about.introButton")} →
          </Link>

        </div>


        <div className="about-intro-card">

          <div className="big-m">
            M
          </div>

          <div className="madad-word">
            <small>MADAD</small>
            <strong>مداد</strong>
          </div>

          <div className="card-decoration">
            ✦
          </div>

        </div>

      </section>


      {/* ================= VISION / MISSION ================= */}

      <section className="about-values section">

        <div className="section-heading">

          <span className="section-tag">
            {t("about.valuesTag")}
          </span>

          <h2>
            {t("about.valuesTitle")}
          </h2>

        </div>


        <div className="values-grid">

          <article className="value-card blue-card">

            <div className="value-number">
              01
            </div>

            <div className="value-icon">
              ◈
            </div>

            <h3>
              {t("about.visionTitle")}
            </h3>

            <p>
              {t("about.visionText")}
            </p>

          </article>


          <article className="value-card yellow-card">

            <div className="value-number">
              02
            </div>

            <div className="value-icon">
              ✦
            </div>

            <h3>
              {t("about.missionTitle")}
            </h3>

            <p>
              {t("about.missionText")}
            </p>

          </article>


          <article className="value-card red-card">

            <div className="value-number">
              03
            </div>

            <div className="value-icon">
              ✓
            </div>

            <h3>
              {t("about.goalsTitle")}
            </h3>

            <p>
              {t("about.goalsText")}
            </p>

          </article>

        </div>

      </section>


      {/* ================= WHY MADAD ================= */}

      <section className="about-why section">

        <div className="why-box">

          <div className="why-number">
            04
          </div>

          <div className="why-content">

            <span className="section-tag">
              {t("about.whyTag")}
            </span>

            <h2>
              {t("about.whyTitle")}
            </h2>

            <p>
              {t("about.whyText")}
            </p>


            <div className="why-points">

              <div>
                <span>✓</span>
                {t("about.point1")}
              </div>

              <div>
                <span>✓</span>
                {t("about.point2")}
              </div>

              <div>
                <span>✓</span>
                {t("about.point3")}
              </div>

              <div>
                <span>✓</span>
                {t("about.point4")}
              </div>

            </div>

          </div>

        </div>

      </section>


      {/* ================= CTA ================= */}

      <section className="about-cta">

        <div className="cta-decoration">
          ✦
        </div>

        <span>
          {t("about.ctaTag")}
        </span>

        <h2>
          {t("about.ctaTitle")}
        </h2>

        <p>
          {t("about.ctaText")}
        </p>

        <Link
          to="/registration"
          className="cta-button"
        >
          {t("about.ctaButton")} →
        </Link>

      </section>

    </main>
  );
}

export default About;